<template>
  <div class="row">
    <div class="login pt-5">
      <center><h5>CỐ VẤN PHONG THUỶ</h5></center>
      <center><p>Trợ lý tâm linh dành riêng cho từng người</p></center>
      <div class="col-12 col-md-4 offset-md-4 mt-2">
        <form action="#">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-phone"/></div>
            </div>
            <input
              id="inlineFormInputGroup"
              v-model="user.phone"
              type="text"
              required
              class="form-control"
              placeholder="Số điện thoại">
          </div>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-lock"/></div>
            </div>
            <input
              v-model="user.password"
              type="password"
              required
              class="form-control"
              placeholder="Mật khẩu">
          </div>
        </form>
      </div>
      <div class="col-12 mt-4">
        <center><router-link
          to="/forgot_pass"
          class="text-secondary my-5 text_css">Bạn quên mật khẩu</router-link></center>
      </div>
      <div class="col-12 col-md-4 offset-md-4">
        <button
          type="button"
          class="btn btn-order bg-green mt-4"
          @click="login()">Đăng nhập
        </button>
      </div>
      <div class="col-12">
        <div class="signup">
          <center><p class="text-secondary mt-5">Bạn chưa phải thành viên?</p></center>
          <center>
            <router-link
              to="/signup"
              class="text-success">ĐĂNG KÝ NGAY</router-link></center>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import rf from '../../communicate/RequestFactory'
  import {errorToaster, infoToaster} from '../../services/ErrorHandler'
  import {setCurrentUser, setToken} from '../../services/authService'

  export default {
    name: 'Login',

    data () {
      return {
        user: {
          phone: '',
          password: ''
        }
      }
    },

    mounted () {
      this.user.phone = ''
      this.user.password = ''
    },

    methods: {
      login () {
        // eslint-disable-next-line no-console
        console.log("User = ", this.user);
        if (this.validateInput(this.user)) {
          rf.getRequest('LoginRequest').login(this.user).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              setCurrentUser(data);

              setToken(data.token);

              this.$emit('LoginEvent', data);
              this.$emit('update:message', data);
              this.$emit('message', data);
              // goto home
              this.$router.push(this.$route.query.from || "/");
            } else {
              errorToaster('Cố vấn Phong Thủy', res.message)
            }
          }).catch(err => {
            errorToaster('Cố vấn phong thủy', 'Xảy ra lỗi kết nối')
          })
        }
      },

      validateInput (user) {
        if (!user.phone || user.phone.length < 8 || user.phone.length > 12) {
          infoToaster('Cố vấn Phong Thủy', 'Số điện thoại không chính xác')
          return false
        }
        if (!user.password || user.password.length < 6) {
          infoToaster('Cố vấn Phong Thủy', 'Mật khẩu đăng nhập không chính xác')
          return false
        }
        return true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue